import { getDisplayState, PaywallDisplay } from 'redux/slices/paywall'
import { userHasPurchasedTicket } from 'redux/slices/passes'

import ChoosePassTier from 'components/set/ChoosePassTier/ChoosePassTier'
import InteractionWidget from 'components/set/InteractionWidget/InteractionWidget'
import Paywall from 'components/set/Paywall/Paywall'
import PaywallCodeRedemption from 'components/set/PaywallCodeRedemption/PaywallCodeRedemption'
import PaywallPrompt from 'components/set/PaywallPrompt/PaywallPrompt'
import PaywallPurchaseSuccessConf from 'components/set/PaywallPurchaseSuccessConf/PaywallPurchaseSuccessConf'
import PaywallPurchaseSuccessSignup from 'components/set/PaywallPurchaseSuccessSignup/PaywallPurchaseSuccessSignup'
import PaywallRedemptionSuccess from 'components/set/PaywallRedemptionSuccess/PaywallRedemptionSuccess'
import PaywallSuccessToast from 'components/set/PaywallSuccessToast/PaywallSuccessToast'
import React from 'react'
import { useSelector } from 'react-redux'
import PaywallFreeTierEmail from 'components/set/PaywallEmailConfirmation/PaywallEmailConfirmation'
import ReedemOnly from 'components/set/RedeemOnly/ReedemOnly'
import { getRemainingPasses } from 'redux/slices/liveShow'
import { useAuth0 } from 'libs/web-client/utils/auth0/src'

const InteractionWidgetWrapper = () => {
    const displayState = useSelector(getDisplayState)
    const remainingPasses = useSelector(getRemainingPasses)
    const { isAuthenticated } = useAuth0()

    const userPurchasedTicket = useSelector(userHasPurchasedTicket)

    if (userPurchasedTicket && displayState === PaywallDisplay.ACCESS) {
        return <InteractionWidget />
    }
    switch (displayState) {
        case PaywallDisplay.PROMPT:
            return <PaywallPrompt />

        case PaywallDisplay.PAYMENT:
            return <Paywall remainingPasses={remainingPasses} isAuthenticated={isAuthenticated} />

        case PaywallDisplay.CHOOSE_PASS_TIER:
            return <ChoosePassTier />

        case PaywallDisplay.CODE_REDEMPTION:
            return <PaywallCodeRedemption />

        case PaywallDisplay.SUCCESS_TOAST:
            return <PaywallSuccessToast />

        case PaywallDisplay.PURCHASE_SUCCESS_SIGNUP:
            return <PaywallPurchaseSuccessSignup />

        case PaywallDisplay.SUCCESS_REDEMPTION:
            return <PaywallRedemptionSuccess />

        case PaywallDisplay.SUCCESS_CONFIRMATION:
            return <PaywallPurchaseSuccessConf />

        case PaywallDisplay.FREE_TIER_EMAIL:
            return <PaywallFreeTierEmail />

        case PaywallDisplay.REDEEM_ONLY:
            return <ReedemOnly />

        default:
            return <InteractionWidget />
    }
}
export default InteractionWidgetWrapper
